import styled from 'styled-components'
import { StyledButton, colors, theme, px2rem, darken } from '../Global'

export const LightGreyButton = styled(StyledButton)`
  &&& {
    color: ${theme.colors.text};
    background-color: ${colors.lightGrey};
    border: ${px2rem(1)}rem solid ${colors.lightGrey};
    :hover{
       background-color: ${darken(colors.lightGrey, 0.2)};
    }
  }
`
